import { render, staticRenderFns } from "./answerDetail.vue?vue&type=template&id=549851dd&scoped=true&"
import script from "./answerDetail.vue?vue&type=script&lang=js&"
export * from "./answerDetail.vue?vue&type=script&lang=js&"
import style0 from "./answerDetail.vue?vue&type=style&index=0&id=549851dd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "549851dd",
  null
  
)

export default component.exports